import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/icons/ic-arrow-right-on-rectangle-area-outline-purple.png")